import { ROUTES } from "@/domain/constants/routes";
import { Link } from "react-router-dom";

export function FeaturesSection() {
  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-earth-green mb-4 handwriting">
            我們的服務特色
          </h2>
          <p className="text-xl text-tea-brown max-w-2xl mx-auto">
            就像阿嬤熬湯的用心，我們為每一家企業量身訂做最適合的服務
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-warm-beige rounded-xl p-8 soft-hover warm-shadow">
            <div className="w-16 h-16 bg-earth-green/10 rounded-full flex items-center justify-center mb-6">
              <i className="fas fa-brain text-2xl text-earth-green"></i>
            </div>
            <h3 className="text-xl font-semibold text-earth-green mb-4 handwriting">
              智慧分析建議
            </h3>
            <p className="text-tea-brown leading-relaxed mb-6">
              運用 AI
              技術深度了解您的事業，提供如老師傅般精準的經營建議，讓決策更有信心。
            </p>
            <Link to={ROUTES.LOGIN} className="text-earth-green font-medium">
              <i className="fas fa-arrow-right mr-2"></i>深入了解
            </Link>
          </div>

          <div className="bg-warm-beige rounded-xl p-8 soft-hover warm-shadow">
            <div className="w-16 h-16 bg-earth-green/10 rounded-full flex items-center justify-center mb-6">
              <i className="fas fa-home text-2xl text-earth-green"></i>
            </div>
            <h3 className="text-xl font-semibold text-earth-green mb-4 handwriting">
              在地化貼心服務
            </h3>
            <p className="text-tea-brown leading-relaxed mb-6">
              我們深深了解台中企業的需要，用最親切的台灣話溝通，提供最貼近在地的解決方案。
            </p>
            <Link to={ROUTES.LOGIN} className="text-earth-green font-medium">
              <i className="fas fa-arrow-right mr-2"></i>深入了解
            </Link>
          </div>

          <div className="bg-warm-beige rounded-xl p-8 soft-hover warm-shadow">
            <div className="w-16 h-16 bg-earth-green/10 rounded-full flex items-center justify-center mb-6">
              <i className="fas fa-handshake text-2xl text-earth-green"></i>
            </div>
            <h3 className="text-xl font-semibold text-earth-green mb-4 handwriting">
              簡單易懂操作
            </h3>
            <p className="text-tea-brown leading-relaxed mb-6">
              不需要複雜的技術知識，就像使用手機一樣簡單，讓您專心做生意，其他交給我們。
            </p>
            <Link to={ROUTES.LOGIN} className="text-earth-green font-medium">
              <i className="fas fa-arrow-right mr-2"></i>深入了解
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
